export default __webpack_public_path__ + "static/media/iconMinusBlack.c5d60a4a.svg";